/**
 * File: ContactModal.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.3.5
 * Created: 2025-12-28
 * Last Updated: 2026-06-04
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useLayoutEffect, useState } from "react";

// Local project files
import { contactModal } from "../../schemas/components/contactModal";
import { TextButton } from "../ui/Buttons";
import DropDownField from "../forms/DropDownField";
import EmailField from "../forms/EmailField";
import FormHeader from "../forms/FormHeader";
import ModalOverlay from "../ui/ModalOverlay";
import PhoneNumberField from "../forms/PhoneNumberField";
import TextField from "../forms/TextField";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function ContactModal({ onClose }) {
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [subject, setSubject] = useState("");
    const [message, setMessage] = useState("");

    const [uiWidth, setUiWidth] = useState(() => window.innerWidth);

    useLayoutEffect(() => {
        const handleResize = () => setUiWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        onClose();

        try {
            await fetch(
                `${process.env.REACT_APP_NOTIFICATION_URL}/emails/contact`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        firstName,
                        lastName,
                        phoneNumber,
                        email,
                        subject,
                        message,
                    }),
                },
            );
        } catch (error) {
            console.error("Error submitting contact form:", error);
        }
    };

    return (
        <>
            {uiWidth < 600 ? <ModalOverlay onClick={onClose} /> : null}
            <div className="contact-modal">
                <form onSubmit={handleSubmit} className="contact-modal__form">
                    <FormHeader
                        header={contactModal.formHeader.header}
                        subheader={contactModal.formHeader.subheader}
                        closeButton={true}
                        onClick={onClose}
                        alignLeft={true}
                    />
                    <fieldset>
                        <div className="contact-modal__row-container">
                            <div className="contact-modal__column-container">
                                <TextField
                                    label={
                                        contactModal.textField.firstName.label
                                    }
                                    text={firstName}
                                    setText={setFirstName}
                                />
                            </div>
                            <div className="contact-modal__column-container">
                                <TextField
                                    label={
                                        contactModal.textField.lastName.label
                                    }
                                    text={lastName}
                                    setText={setLastName}
                                />
                            </div>
                        </div>
                        <div className="contact-modal__row-container">
                            <div className="contact-modal__column-container">
                                <PhoneNumberField
                                    phoneNumber={phoneNumber}
                                    setPhoneNumber={setPhoneNumber}
                                />
                            </div>
                            <div className="contact-modal__column-container">
                                <EmailField email={email} setEmail={setEmail} />
                            </div>
                        </div>
                        <DropDownField
                            label={contactModal.dropDownField.label}
                            options={contactModal.dropDownField.options}
                            selection={subject}
                            setSelection={setSubject}
                        />
                        <TextField
                            label={contactModal.textField.message.label}
                            text={message}
                            setText={setMessage}
                        />
                    </fieldset>
                    <TextButton
                        text={contactModal.textButton.text}
                        type={contactModal.textButton.type}
                    />
                </form>
            </div>
        </>
    );
}

export default ContactModal;
